import ButtonClick from './buttonClick'
import ButtonLink from './buttonLink'
import Inner from './inner'

const RectangleButton = ({
  name,
  link,
  onClick,
  type = 'button',
  className = '',
  size = 'small',
  color = 'primary',
  ...args
}) => {
  if (link) {
    return (
      <ButtonLink
        name={name}
        link={link}
        color={color}
        size={size}
        className={className}
        {...args}
      />
    )
  } else if (onClick) {
    return (
      <ButtonClick
        name={name}
        type={type}
        onClick={onClick}
        color={color}
        size={size}
        className={className}
        {...args}
      />
    )
  }

  const base =
    'relative w-fit overflow-hidden px-[18px] py-[15px] md:px-[35px] md:py-[25px] text-rectangleBigButtonMobile md:text-rectangleBigButtonDesktop border border-olive text-olive font-ttDrugsTrial uppercase group transition-all duration-500'

  return (
    <div {...args} className={`${base} ${className}`}>
      <Inner name={name} color={color} />
    </div>
  )
}

export default RectangleButton
